import { v4 as uuidv4 } from "uuid";
import { FormInputTypes, EditableTypes, ItemTypes } from '../../../shareable/types';
import { getDefaultText, getImageDefault, getDefaultSocial } from '../../helpers';

export default {
    name:'Section',
    inputs:{
        backgroundColor: {
            label: 'Couleur de fond',
            type: FormInputTypes.COLOR,
            value: '#DEEDF5'
        },
        backgroundImage: {
            label: 'Image de fond',
            type: FormInputTypes.IMAGE,
            value: null
        }
    },
    blocks: {
        logo: getImageDefault(),
        socialBlock:{
            id: uuidv4(),
            name: "Bloc réseaux sociaux",
            type: EditableTypes.MINI_BLOCKS,
            inputs:{
                backgroundColor: {
                    label: 'Couleur de fond',
                    type: FormInputTypes.COLOR,
                    value: '#fffff'
                },
                backgroundImage: {
                    label: 'Image de fond',
                    type: FormInputTypes.IMAGE,
                    value: null
                },
                position: {
                    type: FormInputTypes.SELECT,
                    label: "Position du texte",
                    value: 'inline',
                    params: [{label: 'En ligne', value: 'inline'}, {label: 'Au dessus', value: 'top'}, {label: 'Au dessous', value: 'bottom'}]
                }
            },
            blocks: {
                shareText: getDefaultText("Texte de partage", "Texte de partage", 20, '#53839D', 'rgba(0,0,0,0)'),
                social:{
                    title: "Réseau social",
                    name: "Réseaux sociaux",
                    type: EditableTypes.MULTIPLE_BLOCKS,
                    subtype: ItemTypes.SOCIAL,
                    limit: 3,
                    config: [
                        getDefaultSocial(),
                        getDefaultSocial(),
                    ]
                },
            }
        }
    }
};